/* tslint:disable */
/* eslint-disable */
export enum ApplicationDocumentType {
  Unspecified = 'Unspecified',
  Vosa = 'Vosa',
  Cin = 'Cin',
  Insurance = 'Insurance',
  BankStatement = 'BankStatement',
  DriverLicense = 'DriverLicense',
  Identification = 'Identification',
  BiometricReport = 'BiometricReport',
  CirForm = 'CirForm',
  ProofOfAddress = 'ProofOfAddress',
  DirectorDueDiligence = 'DirectorDueDiligence',
  Payslip = 'Payslip',
  IrdStatement = 'IrdStatement',
  MsdStatement = 'MsdStatement',
  EmploymentAgreementOrContract = 'EmploymentAgreementOrContract',
  RentalIncomeEvidence = 'RentalIncomeEvidence',
  SelfEmployedFinancials = 'SelfEmployedFinancials',
  CompanyFinancials = 'CompanyFinancials',
  MojStatement = 'MOJStatement',
  PrivateSaleAgreement = 'PrivateSaleAgreement',
  SettlementStatementsForDebtConsolidation = 'SettlementStatementsForDebtConsolidation',
  VisaCopy = 'VisaCopy',
  VehicleInsurance = 'VehicleInsurance',
  ThirdPartyInsurance = 'ThirdPartyInsurance',
  LoanContractDocuments = 'LoanContractDocuments',
  Other = 'Other'
}
